
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard } from '@/components';
import { usePromotionCycleList } from '@/modules/promotion/cycle/model/list';
import { statusOption } from '@/modules/promotion/cycle/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.CYCLE.INDEX,
    components: { AppTable, AppCard },
    setup() {
        const { list, total, query, fetchList } = usePromotionCycleList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Promotion Plan',
                    key: 'promotionPlanName',
                    to: row => row.promotionPlanLink
                },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: statusOption },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.DateTime, label: 'End Time', key: 'endTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROMOTION.CYCLE.DETAIL, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList };
    }
});
